import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, RefreshCw, LogIn } from 'lucide-react';
import { Button } from './ui/button';

export const ErrorBanner = ({ message, onRetry, isAuthError }) => {
  const navigate = useNavigate();

  return (
    <div
      className="flex flex-col items-center justify-center gap-4 py-16 px-4 text-center"
      data-testid="error-banner"
    >
      <div className="w-14 h-14 rounded-full bg-destructive/10 flex items-center justify-center">
        <AlertTriangle className="h-6 w-6 text-destructive" />
      </div>
      <div>
        <h3 className="text-base font-semibold text-foreground mb-1">
          {isAuthError ? 'Session Expired' : 'Something went wrong'}
        </h3>
        <p className="text-sm text-muted-foreground max-w-sm">
          {message || 'We couldn\u2019t load this page. Please try again.'}
        </p>
      </div>
      <div className="flex gap-3">
        {isAuthError ? (
          <Button
            onClick={() => navigate('/login')}
            className="bg-primary text-primary-foreground hover:bg-primary/90"
            size="sm"
            data-testid="error-login-btn"
          >
            <LogIn className="h-4 w-4 mr-2" />
            Sign In
          </Button>
        ) : onRetry ? (
          <Button
            onClick={onRetry}
            variant="outline"
            size="sm"
            data-testid="error-retry-btn"
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            Try Again
          </Button>
        ) : null}
      </div>
    </div>
  );
};
